import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="pt-10 pb-8 px-4 sm:px-6 bg-cream text-center border-b-4 border-ivory" data-id="element-94">
      <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gold/10 border border-gold/30 text-petrol font-body font-bold text-xs sm:text-sm mb-5 shadow-sm" data-id="element-95">
        <span className="text-base leading-none" data-id="element-96">✨</span>
        <span className="tracking-widest uppercase" data-id="element-97">
          VALIDATED COACHING SYSTEM
        </span>
      </div>

      <h1 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold text-petrol leading-[1.1] mb-4" data-id="element-98">
        The Complete Planning System for Senior Fitness Professionals
      </h1>

      <p className="text-lg sm:text-xl text-graphite font-subheading font-semibold leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-99">
        Save hours of planning, deliver safer sessions, and help older adults
        move with confidence — without creating classes from scratch.
      </p>

      <div className="inline-block bg-sage text-white px-5 py-2 rounded-md mb-6 shadow-md" data-id="element-100">
        <p className="font-body font-bold text-sm sm:text-base tracking-widest uppercase" data-id="element-101">
          FITNESS SENIOR READY™ 6-in-1 Box Set
        </p>
      </div>

      <div className="mb-8" data-id="element-102">
        <a href="#pricing" className="block cursor-pointer" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/3BY8BrEsHe6M5N1YF9C6Vd/ChatGPT-Image-16-jun-2026_-15_07_04.webp" alt="FITNESS SENIOR READY 6-in-1 Box Set" className="w-full h-auto object-contain max-w-[320px] sm:max-w-lg mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-104" />
        </a>
      </div>

      <div className="mb-5 max-w-lg mx-auto" data-id="element-105">
        <CTAButton data-id="element-106">🚀 YES, I WANT MY SYSTEM NOW</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs sm:text-sm text-graphite font-bold" data-id="element-107">
        <div className="flex items-center gap-1.5" data-id="element-108">
          <Star className="w-4 h-4 fill-gold text-gold" data-id="element-109" />
          <span data-id="element-110">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-111">
          <ShieldCheck className="w-4 h-4 text-sage" data-id="element-112" />
          <span data-id="element-113">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}